module.exports = __webpack_public_path__ + "static/turquia-021.thumb-1c895286e25f510ab4de01dd33a677f2.jpg";